// 基于准备好的dom，初始化echarts实例
var myChart = echarts.init(document.getElementById('skills'));
// 指定图表的配置项和数据
var option = {
    tooltip: {
        trigger: 'item'
    },
    series: [
        {
            name: "\u6280\u80FD",
            type: 'pie',
            radius: '50%',
            data: [
                {
                    value: 100,
                    name: "\u9759\u6001\u9875\u9762"
                },
                {
                    value: 70,
                    name: "\u7F16\u7A0B\u57FA\u7840"
                },
                {
                    value: 80,
                    name: 'Vue'
                },
                {
                    value: 90,
                    name: 'React'
                },
                {
                    value: 85,
                    name: "\u9879\u76EE\u5F00\u53D1"
                },
                {
                    value: 70,
                    name: "\u6C9F\u901A\u80FD\u529B"
                }
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};
// 使用刚指定的配置项和数据显示图表。
myChart.setOption(option);

//# sourceMappingURL=cv.3527dc24.js.map
